import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56659ddb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: "loading",
  class: "machine-data-card machine-data-card--loading",
  "aria-busy": "true"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "machine-data-card__top" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "machine-data-card__thumb-wrap machine-data-skeleton" }),
  /*#__PURE__*/_createElementVNode("div", { class: "machine-data-card__content w-100" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "machine-data-card__title-skeleton machine-data-skeleton" }),
    /*#__PURE__*/_createElementVNode("div", { class: "machine-data-card__badges" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "machine-data-card__badge-skeleton machine-data-skeleton" }),
      /*#__PURE__*/_createElementVNode("span", { class: "machine-data-card__badge-skeleton machine-data-skeleton" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "machine-data-card__stats" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "machine-data-card__stat-skeleton machine-data-skeleton" }),
      /*#__PURE__*/_createElementVNode("div", { class: "machine-data-card__stat-skeleton machine-data-skeleton" }),
      /*#__PURE__*/_createElementVNode("div", { class: "machine-data-card__stat-skeleton machine-data-skeleton" })
    ])
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "machine-data-card__action-skeleton machine-data-skeleton" }, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: "content",
  class: "machine-data-card"
}
const _hoisted_6 = { class: "machine-data-card__top" }
const _hoisted_7 = { class: "machine-data-card__thumb-wrap" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = ["alt"]
const _hoisted_10 = { class: "machine-data-card__content" }
const _hoisted_11 = { class: "machine-data-card__title" }
const _hoisted_12 = { class: "machine-data-card__badges" }
const _hoisted_13 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_14 = { class: "machine-data-card__stats" }
const _hoisted_15 = { class: "machine-data-card__stat" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-right-fill" }, null, -1))
const _hoisted_17 = { class: "machine-data-card__stat" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-right-fill" }, null, -1))
const _hoisted_19 = { class: "machine-data-card__stat" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-caret-right-fill" }, null, -1))
const _hoisted_21 = ["href"]

import { computed } from "vue";
import type { IMachine } from "@/modern/types/dashboard";


export default /*#__PURE__*/_defineComponent({
  props: {
    machine: null,
    currentLanguage: null,
    href: { default: "" },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { machine: IMachine, currentLanguage: string, href: string, loading: boolean }



const DIFFICULTY_CLASS: Record<string, string> = {
    easy: "badge-light-success",
    medium: "badge-light-info",
    hard: "badge-light-warning",
    insane: "badge-light-danger",
};

const machineLink = computed(() => {
    if (props.href) {
        return props.href;
    }

    return `/laboratory/competition-machines/${props.machine.id}`;
});

const normalizedDifficulty = computed(() => String(props.machine.dificulty || "").toLowerCase());

const normalizedType = computed(() => {
    const t = String(props.machine.type || "");
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "machine-data-fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (__props.loading)
        ? (_openBlock(), _createElementBlock("article", _hoisted_1, _hoisted_4))
        : (_openBlock(), _createElementBlock("article", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (__props.machine.photo_path)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: __props.machine.photo_path,
                      alt: __props.machine.name,
                      class: "machine-data-card__thumb"
                    }, null, 8, _hoisted_8))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: "/media/machines-big.svg",
                      alt: __props.machine.name,
                      class: "machine-data-card__thumb"
                    }, null, 8, _hoisted_9))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h4", _hoisted_11, _toDisplayString(__props.machine.name), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge", DIFFICULTY_CLASS[_unref(normalizedDifficulty)] || 'badge-light'])
                  }, _toDisplayString(_unref(normalizedDifficulty) || __props.machine.dificulty), 3),
                  (_unref(normalizedType))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(normalizedType)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, [
                    _hoisted_16,
                    _createTextVNode(" " + _toDisplayString(__props.machine.total_flags) + " flags", 1)
                  ]),
                  _createElementVNode("p", _hoisted_17, [
                    _hoisted_18,
                    _createTextVNode(" OS: " + _toDisplayString(__props.machine.os_name), 1)
                  ]),
                  _createElementVNode("p", _hoisted_19, [
                    _hoisted_20,
                    _createTextVNode(" XP: " + _toDisplayString(__props.machine.xp), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("a", {
              href: _unref(machineLink),
              class: "btn machine-data-card__action"
            }, _toDisplayString(_ctx.$t(`${__props.currentLanguage}.common.play_now`)), 9, _hoisted_21)
          ]))
    ]),
    _: 1
  }))
}
}

})